import { useCallback } from 'react';
import { useImmerAtom, useSetImmerAtom } from 'jotai-immer';

import { tableDataVM } from '../../../../core/table/table_view_models';

// get list!
import { pageStateAtom, iraDataAtom } from '../ira_list_atoms';
import { IraDataItem, IraListStoreHook } from '../../ira_types';
import { iraRepo } from '../../data/iraRepo';

export const useIraListStore = (): IraListStoreHook => {
    const [state, setState] = useImmerAtom(pageStateAtom);
    const setList = useSetImmerAtom(iraDataAtom);

    const getListAsync = useCallback(async () => {
        try {
            const r = await iraRepo.getList();
            setList(draft => {
                draft.dataItems = r as IraDataItem[];
                draft.items = [];
            });
        } catch (err: any) {
            // err msg handled upstream
            setList(() => tableDataVM<IraDataItem>());
        } finally {
            setState(draft => {
                draft.loading = false;
                return draft;
            });
        }
    }, [setList, setState]);

    const getList = useCallback((): void => {
        setState(draft => {
            draft.loading = true;
            return draft;
        });
        getListAsync();
    }, [getListAsync, setState]);

    return {
        ...state,
        getList,
    };
};
